export const BucketTypes = {
	Manual: 0,
	Balanced: 1,
	Conservative: 2,
};
